import { createToastQueue } from './createToastQueue';

export const errorQueue = createToastQueue({ maxCount: 1 });
export const successQueue = createToastQueue({ maxCount: 2 });
export const warningQueue = createToastQueue({ maxCount: 1 });
